<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('finance_accounts')">
            <app-default-button class="mr-2"
                :title="$fieldTitle('add', 'account', true)"
                v-if="$can('create_finance_accounts')"
                @click="openModal()"
            />
            <!-- <app-default-button class="btn-success mr-2"
                :title="$t('transfer')"
                v-if="$can('create_transfer_accounts')"
                @click="redirectTo('/finance/transfers')"
            />
            <app-default-button class="btn-success"
                :title="$t('transaction')"
                v-if="$can('create_transaction_accounts')"
                @click="redirectTo('/finance/transactions')"
            /> -->
        </app-page-top-section>

        <app-table
            id="finance-account-table"
            :options="options"
            @action="triggerActions"
        />

        <div class="card card-with-shadow border-0 mt-4" v-if="accountDataSets[0].data.length > 0">
            <!-- <div class="card-header d-flex align-items-center justify-content-between primary-card-color p-primary">
                <h5 class="mb-0">{{ $t('finance_accounts_balance_distribution') }}</h5>
            </div> -->
            <div class="card-body p-primary">
                <app-chart
                    type="dough-chart"
                    :height="450"
                    :labels="accountLabels"
                    :data-sets="accountDataSets"
                    :show-legend="true"
                    :key="chartKey"
                />
            </div>
        </div>

        <app-finance-account-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-finance-transaction-create
            v-if="isTransactionModalActive"
            v-model="isTransactionModalActive"
            :default-type="transactionType"
            :default-source-account-id="selectedAccountId"
        />

        <app-finance-transfer-create
            v-if="isTransferModalActive"
            v-model="isTransferModalActive"
            :default-source-account-id="selectedAccountId"
        />

        <app-finance-account-import
            v-if="isImportModalActive"
            v-model="isImportModalActive"
            :account-id="selectedAccountId"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('finance-account-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import FinanceAccountMixin from "../../Mixins/FinanceAccountMixin";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import {axiosGet} from "../../../../common/Helper/AxiosHelper";

export default {
    name  : "FinanceAccount",
    mixins: [HelperMixin, FinanceAccountMixin],
    data() {
        return {
            isModalTypeActive: false,
            isModalActive    : false,
            selectedUrl      : '',
            accountLabels    : [],
            chartKey         : 0,
            accountDataSets  : [
                {
                    borderWidth: 0,
                    backgroundColor: [],
                    data: []
                }
            ],
            isTransactionModalActive: false,
            transactionType: 'income',
            isTransferModalActive: false,
            selectedAccountId: '',
            isImportModalActive: false,
        }
    },
    mounted() {
        this.loadAccountDataForChart();
        
        // Listen for reload event
        this.$hub.$on('reload-finance-account-table', () => {
            this.loadAccountDataForChart();
        });
    },
    beforeDestroy() {
        // Remove event listener to prevent memory leaks
        this.$hub.$off('reload-finance-account-table');
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.name === 'add_income') {
                this.openIncomeTransactionModal(row);
            } else if (action.name === 'add_expense') {
                this.openExpenseTransactionModal(row);
            } else if (action.name === 'add_transfer') {
                this.openTransferModal(row);
            } else if (action.name === 'import') {
                this.selectedAccountId = row.id;
                this.isImportModalActive = true;
            } else if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/finance-accounts/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
        openIncomeTransactionModal(row) {
            this.transactionType = 'income';
            this.selectedAccountId = row.id;
            this.isTransactionModalActive = true;
        },
        openExpenseTransactionModal(row) {
            this.transactionType = 'expense';
            this.selectedAccountId = row.id;
            this.isTransactionModalActive = true;
        },
        openTransferModal(row) {
            this.selectedAccountId = row.id;
            this.isTransferModalActive = true;
        },
        loadAccountDataForChart() {
            axiosGet(`${TENANT_BASE_URL}app/finance-accounts?all=1`)
                .then(response => {
                    const accounts = response.data.data || response.data;
                    
                    this.accountLabels = accounts.map(account => account.name);
                    this.accountDataSets[0].data = accounts.map(account => parseFloat(account.balance));
                    
                    // Use account's color property, fallback to default colors if not set
                    const defaultColors = [
                        '#5cde64', '#ea833a', '#df4736', '#ee00ff', '#36a2eb', '#ffcd56',
                        '#4dffa2', '#ff6b6b', '#6b5e99', '#ff9f40', '#4bc0c0', '#966ff5'
                    ];
                    this.accountDataSets[0].backgroundColor = accounts.map((account, index) => {
                        return account.color || defaultColors[index % defaultColors.length];
                    });

                    this.chartKey += 1;
                })
                .catch(error => {
                    console.error('Error loading account data for chart:', error);
                });
        }
    }
}
</script>

<style scoped>
::v-deep .btn-success {
    color: #ffffff !important;
    background-color: #46c35f !important;
    border-color: #46c35f !important;
}
</style>
